import React, { useCallback, useEffect, useState } from 'react';
import { api, brl, dateStr } from '../lib/api';
import { toast } from 'sonner';
import { Plus, Trash2, X } from 'lucide-react';
import { useAuth } from '../lib/auth';

export default function Finance() {
  const { user } = useAuth();
  const [expenses, setExpenses] = useState([]);
  const [dash, setDash] = useState(null);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ description: '', amount: '', category: 'Geral' });

  const load = useCallback(async () => {
    const [e, d] = await Promise.all([api.get('/expenses'), api.get('/reports/dashboard?period=month')]);
    setExpenses(e.data); setDash(d.data);
  }, []);
  useEffect(() => { load(); }, [load]);

  const submit = async () => {
    if (!form.description.trim() || !Number(form.amount)) { toast.error('Preencha os campos'); return; }
    await api.post('/expenses', { ...form, amount: Number(form.amount) });
    toast.success('Despesa registrada');
    setModal(false); setForm({ description: '', amount: '', category: 'Geral' }); load();
  };

  const remove = async (id) => {
    if (!window.confirm('Excluir despesa?')) return;
    try { await api.delete(`/expenses/${id}`); load(); } catch { toast.error('Somente admin'); }
  };

  return (
    <div className="p-4 h-full overflow-y-auto space-y-4">
      <h2 className="text-xl font-black">Financeiro (mês)</h2>
      {dash && (
        <div className="grid grid-cols-2 gap-3">
          <Card label="Receita" v={brl(dash.revenue)} c="text-orange-600"/>
          <Card label="Custo produtos" v={brl(dash.cost)} c="text-slate-800"/>
          <Card label="Lucro bruto" v={brl(dash.profit)} c="text-green-600"/>
          <Card label="Despesas" v={brl(dash.expenses)} c="text-red-600"/>
          <Card label="Perdas" v={brl(dash.losses)} c="text-amber-600"/>
          <Card label="Resultado líquido" v={brl(dash.net_result)} c={dash.net_result >= 0 ? 'text-green-600' : 'text-red-600'}/>
        </div>
      )}

      <div className="flex items-center justify-between">
        <h3 className="font-bold">Despesas</h3>
        <button onClick={() => setModal(true)} data-testid="expense-new" className="h-9 px-4 rounded-xl bg-orange-500 text-white font-bold text-sm flex items-center gap-1 active:scale-95"><Plus size={16}/> Nova</button>
      </div>
      <div className="space-y-1">
        {expenses.map((e) => (
          <div key={e.id} className="bg-white rounded-lg border border-slate-100 p-2 text-sm flex justify-between items-center">
            <div>
              <div className="font-semibold">{e.description}</div>
              <div className="text-xs text-slate-500">{dateStr(e.timestamp)} · {e.category} · {e.username}</div>
            </div>
            <div className="flex items-center gap-2">
              <div className="font-black text-red-600">−{brl(e.amount)}</div>
              {user?.role === 'admin' && <button onClick={() => remove(e.id)} className="w-8 h-8 rounded-lg bg-red-50 text-red-600 grid place-items-center"><Trash2 size={14}/></button>}
            </div>
          </div>
        ))}
        {expenses.length === 0 && <div className="text-slate-500 text-sm">Nenhuma despesa</div>}
      </div>

      {modal && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-end sm:items-center sm:justify-center" onClick={() => setModal(false)}>
          <div onClick={(e) => e.stopPropagation()} className="bg-white w-full sm:max-w-md rounded-t-3xl sm:rounded-3xl p-4 space-y-3">
            <div className="flex items-center justify-between"><div className="font-black">Nova despesa</div><button onClick={() => setModal(false)}><X/></button></div>
            <input placeholder="Descrição" value={form.description} onChange={(e) => setForm({...form, description: e.target.value})} data-testid="expense-desc" className="w-full h-11 rounded-xl border border-slate-200 px-3"/>
            <input type="number" step="0.01" placeholder="Valor" value={form.amount} onChange={(e) => setForm({...form, amount: e.target.value})} data-testid="expense-amount" className="w-full h-11 rounded-xl border border-slate-200 px-3"/>
            <input placeholder="Categoria" value={form.category} onChange={(e) => setForm({...form, category: e.target.value})} data-testid="expense-cat" className="w-full h-11 rounded-xl border border-slate-200 px-3"/>
            <button onClick={submit} data-testid="expense-save" className="w-full h-12 rounded-xl bg-orange-500 text-white font-black">Salvar</button>
          </div>
        </div>
      )}
    </div>
  );
}

const Card = ({ label, v, c }) => (
  <div className="bg-white rounded-2xl border border-slate-200 p-3">
    <div className="text-[11px] text-slate-500 font-semibold uppercase">{label}</div>
    <div className={`text-lg font-black ${c}`}>{v}</div>
  </div>
);
